//on close of an alert, set a cookie remembering it was closed
$(document).ready(function () {
    $('[data-cookie-trigger]').each(function () {
        $(this).on('click', function () {
            //alert cookie name is the ID of the alert datasource prefixed with "Alert"
            //alert cookie value is the datasource's revision guid

            var cookieParent = $(this).closest('[data-cookie-dismissible]');

            var cookieName = $(cookieParent).attr('data-cookie-name');
            var cookieValue = $(cookieParent).attr('data-cookie-value');
            var cookieExpiration = $(cookieParent).attr('data-cookie-expiration');
            setCookie(cookieName, cookieValue, cookieExpiration)
        })
    })
});

window.deleteCookie = function deleteCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

window.getCookie = function getCookie(name) {
    var dc = document.cookie;
    var prefix = name + "=";
    var begin = dc.indexOf("; " + prefix);
    if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
    }
    else {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
            end = dc.length;
        }
    }
    // because unescape has been deprecated, replaced with decodeURI
    //return unescape(dc.substring(begin + prefix.length, end));
    return decodeURI(dc.substring(begin + prefix.length, end));
}

window.setCookie = function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

window.getCookieValue = function getCookieValue(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}